export const spanish = {
    completed: 'Completed',
    title: 'Formulario de Autoinforme de Exámenes de Salud',
    measurementYear: 'Año de Medición 2024',
    alignmentMessageTitle: 'Un mensaje de Alignment Health',
    alignmentMessage1: `Hola {name}! Tu bienestar es nuestra prioridad. Los exámenes preventivos son esenciales para mantenerte saludable y detectar posibles problemas a tiempo. Al completar tus exámenes recomendados, das un paso importante para cuidar tu salud y tener mayor tranquilidad.`,
    alignmentMessage2: `🎉 Como muestra de nuestro agradecimiento, recibirás <strong>$30 por cada examen completado</strong> en 2024. ¡Y en 2025, tendrás otra oportunidad de ganar recompensas!`,
    alignmentMessage3: `Tómate un momento para informarnos sobre tus exámenes recientes. Tu participación nos ayuda a seguir apoyándote en tu camino hacia la salud y garantizar que recibas tus merecidas recompensas.`,
    alignmentMessage4: `Hakan Kardes
Director de Experiencia del Cliente
Alignment Health Plan
    `,
    tokenError: 'Hay un error con tu token',
    thankYou: `Gracias. Tus respuestas han sido enviadas.
    Ahora serás redirigido al Portal para Miembros de Alignment Health.`,
    thankYouOK: 'OK',
    breastCancerTitle: 'Examen de Cáncer de Mama (Mamografía realizada entre 01/10/2022 - 31/12/2024)',
    select: 'Seleccionar',
    yes: 'Si',
    no: 'No',
    enterYear: 'Ingresar año',
    enterMonth: 'Ingresar mes',
    colorectalTitle: 'Examen de Cáncer Colorrectal (entre 01/01/2015 y 31/12/2024)',
    colonoscopy: 'Colonoscopía (entre 01/01/2015 y 31/12/2024)',
    cologuard: 'Cologuard (entre 01/01/2022 y 31/12/2024)',
    stoolTest: 'Prueba de heces (FIT/FOBT en cualquier momento en 2024)',
    bloodPressureTestTitle: 'Control de Presión Arterial (Lectura más reciente en 2024, debe ser inferior a 140/90)',
    bloodPressureEnterMostRecentReading: 'Ingresar la lectura más reciente en 2024, debe ser inferior a 140/90',
    needAnyHelp: '¿Necesita ayuda para programar algún examen en 2025?',
    iConfirm: 'Confirmo que la información proporcionada es precisa y puede utilizarse para actualizar mi expediente médico.',
    send: 'Enviar',
    submitError: 'Ingresar la lectura más reciente en 2024, debe ser inferior a 140/90'
};